import { Box, Stack, Typography } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';
import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

// Wrapper component: the generic in-phone load-failure state — icon, title,
// explanation, try again. One pattern for every screen that can fail to load.
const ErrorState = ({
  title,
  body,
  onRetry,
}: {
  title: string;
  body: string;
  onRetry?: () => void;
}) => (
  <Box
    sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      px: 3,
    }}
  >
    <Stack sx={{ alignItems: 'center', width: '100%' }} spacing={2}>
      <Box sx={{ color: 'error.main', display: 'flex' }}>
        <Icon icon='exclamation-triangle' fontSize={32} />
      </Box>
      <Typography variant='h2'>{title}</Typography>
      <Typography variant='body1' color='text.secondary'>
        {body}
      </Typography>
      <Box sx={{ width: '100%', pt: 1 }}>
        <Button
          variant='primary'
          size='lg'
          isFullWidth
          ariaLabel='Try again'
          onPress={onRetry}
        >
          Try again
        </Button>
      </Box>
    </Stack>
  </Box>
);

export default ErrorState;
